import type { IRMetricKey } from '~/presentation/reports/common/type';

import {
  GENERAL_METRIC_INFO,
  REPORT_METRIC_GROUP,
  REPORT_METRIC_INFO,
  REPORT_METRIC_UI,
} from '~/presentation/reports/common';

export function getControlsMetrics(metricKeys: IRMetricKey[]) {
  return metricKeys.map((key) => ({
    ...REPORT_METRIC_UI[key],
    dependentControls: undefined,
  }));
}

export function getConfigMetrics(metricKeys: IRMetricKey[]) {
  const metricSet = new Set<string>(metricKeys);

  const optionsGroup = REPORT_METRIC_GROUP.map((group) => ({
    ...group,
    options: group.options.map((option) => ({
      ...option,
      disabled: metricSet.has(option.value),
    })),
  }));

  return {
    optionsGroup,
    itemInfo: REPORT_METRIC_INFO,
    generalItemInfo: GENERAL_METRIC_INFO,
    controlSettingUI: REPORT_METRIC_UI,
    searchPlaceholder: 'Search metrics',
  };
}

export function getMetricSettingUIs(metricKeys: IRMetricKey[]) {
  return {
    controls: getControlsMetrics(metricKeys),
    config: getConfigMetrics(metricKeys),
  };
}
